const Strings = {
  SIGN_OUT: 'Logga ut',
  CUSTOMERS: 'BRF:er'
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/common/ListItems/strings.js